import { deepcopy } from "../recommender/util";
import { viewSpecs, storeQueue } from "./storage.js";

// important! one CallID == one Rule & one Spec; (exclusively unique!)
export class DupoCallQueue {
  constructor() {
    this.currQueue = [];
    this.processed = [];
    this.canceled = [];
    this.queueSize = 0;
    this.usedCallIDs = [];
  }

  setUsedCallIDs(a) {
    this.usedCallIDs.push(...a);
  }

  add(rules, ids) {
    if (rules && ids) {
      this.currQueue.push(
        { ids, rules }
      );
      this.queueSize++;
    } else if (!rules && !ids) {
      console.warn("Rules and IDs are not provided.")
    } else if (!rules) {
      console.warn("Rules are not provided.")
    } else if (!ids) {
      console.warn("IDs for the rules are not provided.")
    }
    return this;
  }

  add_as_processed(rules, ids) {
    if (rules && ids) {
      this.processed.push(
        { ids, rules }
      );
      storeQueue(this.processed, "processed");
    } else if (!rules && !ids) {
      console.warn("Rules and IDs are not provided.")
    } else if (!rules) {
      console.warn("Rules are not provided.")
    } else if (!ids) {
      console.warn("IDs for the rules are not provided.")
    }
    return this;
  }

  async apply(config) {
    let self = this;
    this.currQueue.forEach(queueItem => {
      viewSpecs.update(specs => {
        specs.forEach(spec => {
          if (queueItem.ids.includes(spec.uid) && queueItem.rules.constructor.name === "Array") {
            let rules = queueItem.rules.map(rule => {
              rule.callID = genCallID(self.usedCallIDs);
              rule.callTime = getCallTime();
              self.usedCallIDs.push(rule.callID);
              return rule;
            });
            if (config?.afterApply?.constructor.name === "Function") {
              config.afterApply(rules, spec);
            } else {
              spec.updateHistory(rules, config);
              spec.storeToCache();
            }
          }
        });
        return specs;
      });
      self.processed.push(deepcopy(queueItem));
      storeQueue(self.processed, "processed");
    });
    if (config?.afterUpdateAll?.constructor.name === "Function") {
      config.afterUpdateAll();
    }
    this.currQueue = [];
    this.queueSize = 0;
    this.canceled = [];
    storeQueue(this.canceled, "canceled");
    return this;
  }

  async cancel(ids, callIDs) {
    let self = this;
    let canceled = {};
    viewSpecs.update(specs => {
      specs.forEach(spec => {
        if (ids.includes(spec.uid)) {
          spec.history = spec.history.map(rule => {
            if (!callIDs.includes(rule.callID)) return rule;
            else {
              canceled[rule.callID] = deepcopy(rule);
              return { callID: rule.callID };
            }
          });
          spec.last_updated = getCallTime();
          spec.changeAfterCheckout = true;
          spec.storeToCache();
        }
      });
      return specs;
    });

    self.canceled.push(
      { ids, items: canceled }
    );
    storeQueue(self.canceled, "canceled");
    return this;
  }

  async undo() {
    let undoItem = this.processed?.[this.processed?.length - 1];
    console.log(undoItem);
    if (undoItem) {
      if (undoItem.isSystemQueue) {
        if (undoItem.message === "apply-recommendation" && undoItem.uid) {
          viewSpecs.update(specs => {
            specs.forEach(async (spec) => {
              if (spec.uid === undoItem.uid) {
                await spec.discardLastRecVersion();
              }
            });
            return specs;
          });
        }
        this.canceled.push(deepcopy(undoItem));
      } else if (undoItem.items) {
        // once redone
        let callIDs = Object.keys(undoItem.items);
        let uids = undoItem.ids;
        this.cancel(uids, callIDs);
      } else {
        let callIDs = undoItem.rules.map((rule) => { return rule.callID });
        let uids = undoItem.ids;
        this.cancel(uids, callIDs);
      }
      this.processed.pop();
      storeQueue(this.processed, "processed");
    }
    return this;
  }

  async revokeImmediate() {
    let revokeItem = this.canceled?.[this.canceled?.length - 1];
    if (revokeItem) {
      if (revokeItem.isSystemQueue) {
        if (revokeItem.message === "apply-recommendation" && revokeItem.uid) {
          viewSpecs.update((specs) => {
            specs.forEach(async (spec) => {
              if (spec.uid === revokeItem.uid) {
                await spec.revertLastDiscardedVersion();
              }
            });
            return specs;
          });
        }
      } else {
        let callIDs = Object.keys(revokeItem.items);
        viewSpecs.update(specs => {
          specs.forEach(spec => {
            if (revokeItem.ids.includes(spec.uid)) {
              spec.history = spec.history.map(rule => {
                if (callIDs.includes(rule.callID) && isEmptyRule(rule)) {
                  return deepcopy(revokeItem.items[rule.callID]);
                } else {
                  return rule;
                }
              });
            }
          });
          return specs;
        });
      }
      this.canceled.pop();
      this.processed.push(deepcopy(revokeItem));
      storeQueue(this.processed, "processed");
    }
    return this;
  }

  async addSystemQueue(q) {
    q.callID = genCallID(this.usedCallIDs);
    q.callTime = getCallTime();
    q.isSystemQueue = true;
    this.processed.push(q);
    storeQueue(this.processed, "processed");
    return this;
  }
}

export function isEmptyRule(rule) {
  if (rule === undefined) return false;
  if (rule.specifier === undefined && rule.action === undefined && rule.option === undefined) return true;
  else return false;
}

export function genCallID(used) {
  let id = randomString();
  // repetition check;
  while (used?.includes(id)) {
    id = randomString();
  }
  return id;
}

const availLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'.split('');
const nLetters = availLetters.length;
const rsLength = 20;
function randomString() {
  return new Array(rsLength).fill(0).map(d => availLetters[Math.floor(Math.random() * nLetters)]).join('');
}

export function getCallTime() {
  return (new Date()).toLocaleString();
}
export function compareCallTime(a, b) {
  // a, b: string
  return (new Date(a)) - (new Date(b));
  // if > 0: a is later, otherwise a is faster
}